(function(){
  function init(){
    var hdr=document.querySelector('.bb-sitehead');
    var chapters=document.querySelectorAll('[data-bbtime]');
    var clock=document.getElementById('bbClock');
    var main=document.querySelector('main')||document.body;
    var firstCh=main.querySelector('.bbc-full,.bbc-film');
    if(hdr&&firstCh){
      var onScroll=function(){hdr.classList.toggle('bb-clear', window.scrollY<window.innerHeight*0.6);};
      window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    }
    if(clock&&chapters.length){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting){
          var t=e.target.getAttribute('data-bbtime');
          if(t){clock.textContent=t;clock.classList.add('on');}
          else{clock.classList.remove('on');}
        }
      });},{threshold:0.45});
      chapters.forEach(function(c){io.observe(c)});
      var end=document.querySelector('footer');
      if(end){new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){clock.classList.remove('on');}});},{threshold:0.1}).observe(end);}
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();